// @ts-nocheck

//////////////////////////////////////
//   This file is auto generated   //
//////////////////////////////////////

import * as System from "./System"
import * as Theasoft_DataClasses_Security from "./Theasoft_DataClasses_Security"
import * as Theasoft_DataClasses_Orchester from "./Theasoft_DataClasses_Orchester"

export type PermissionType = "No" | "Read" | "Write"
export const PermissionType_AllValues = ["No", "Read", "Write"] as const
export const defaultPermissionType: PermissionType = "No"

export type UserPermission = {
  groupId: System.Int32
  optionsFlag: System.Int32
  canWrite: System.Boolean
  options: System.String
  permissionArea: Theasoft_DataClasses_Security.ts_PermissionArea
  orchestraSecurityOptions: Theasoft_DataClasses_Orchester.OrchestraSecurityOptions
}


